import { Component } from '@angular/core';

@Component({
  selector: 'app-parse-request-create-step-card',

  templateUrl: './parse-request-create-step-card.html',
})
export class ParseRequestCreateStepCard {}
